import { Locale } from './types'
import { useLocale as useLocale_ } from 'next-intl'

export default function useLocale() {
  return useLocale_() as Locale
}
